import { getStudentClassesRequest } from '../api/studentClasses.api';

const getAssetUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  const baseUrl = process.env.REACT_APP_API_URL || '';
  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
};

const formatTeacherName = (teacher) =>
  [teacher?.first_name || teacher?.firstName, teacher?.last_name || teacher?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim() ||
  teacher?.teacher_name ||
  teacher?.name ||
  teacher?.full_name ||
  '--';

const normalizeClass = (item, index) => {
  const teachers = Array.isArray(item?.student_class_teachers) ? item.student_class_teachers : [];
  const schedules = Array.isArray(item?.student_class_schedule) ? item.student_class_schedule : [];

  return {
    id:
      item?.id ?? item?.class_id ?? `${item?.class_code || item?.subject_code || 'class'}-${index}`,
    title: item?.subject_name || item?.subject_code || item?.class_code || 'N/A',
    classId: item?.class_code || item?.subject_code || 'N/A',
    status: item?.status || 'N/A',
    grade: `Grade ${item?.grade ?? 'N/A'}`,
    startDate: item?.start_date || schedules[0]?.start_date || '',
    teacherName:
      teachers.length > 0
        ? formatTeacherName(teachers[0])
        : item?.teacher_name || item?.teacher || '',
    teacherId: teachers[0]?.teacher_id || item?.teacher_id || '',
    teacherCode: teachers[0]?.teacher_code || item?.teacher_code || '',
    teacherSlug: teachers[0]?.slug || item?.slug || '',
    teacherAvatar: teachers[0]?.avatar || item?.teacher_avatar || '',
    teacherCount: teachers.length,
    scheduleCount: schedules.length,
    schedules,
    teachers,
    classType: item?.class_type_name || '--',
    medium: item?.medium_name || '--',
  };
};

const getStudentClassList = (student) =>
  student?.student_classes || student?.student?.student_classes || student?.classes || [];

export const getStudentClasses = async (studentId) => {
  const res = await getStudentClassesRequest(studentId);
  const student = res.data?.student || null;
  const studentClasses = getStudentClassList(res.data?.student || res.data || {});

  return {
    student,
    classes: studentClasses.map(normalizeClass),
    studentClassTeachers: res.data?.student_class_teachers || student?.student_class_teachers || [],
    studentClassSchedule: res.data?.student_class_schedule || student?.student_class_schedule || [],
  };
};
